import types from '../types/simpleSnackbar'

export default class categoryList {

  static showMessage(message) {
    return {
      type: types.SHOW_MESSAGE,
      payload: {
        message,
      },
    }
  }

  static hideMessage() {
    return {
      type: types.HIDE_MESSAGE,
    }
  }

}



// WEBPACK FOOTER //
// ./src/common/actions/simpleSnackbar.js